/**
 * Resolves which personalization sentence is shown on the Tryout-Landing
 * for a given token. The original is never modified — only `personalization_use`
 * decides which stored or composed string is rendered.
 */

export type PersonalizationUse =
  | 'original' | 'ai_generated' | 'fallback' | 'custom';

export interface TokenPersonalizationFields {
  personalization_original: string | null;
  personalization_ai_generated: string | null;
  personalization_custom: string | null;
  personalization_use: PersonalizationUse | null;
  berufsgruppe: string | null;
  location: string | null;
}

export function resolvePersonalization(t: TokenPersonalizationFields): string | null {
  switch (t.personalization_use) {
    case 'custom':
      return t.personalization_custom?.trim() || null;
    case 'ai_generated':
      return t.personalization_ai_generated?.trim() || null;
    case 'fallback':
      return composeFallback(t.berufsgruppe, t.location);
    case 'original':
    case null:
    default:
      return t.personalization_original?.trim() || null;
  }
}

export function composeFallback(
  berufsgruppe: string | null,
  location: string | null,
): string | null {
  const b = berufsgruppe?.trim();
  const l = location?.trim();
  if (b && l) {
    return `Für ${b} in ${l} — Estage.ai macht aus einem Foto in Minuten ein verkaufsfertiges Exposé.`;
  }
  if (b) {
    return `Für ${b} — Exposés in Minuten statt Tagen.`;
  }
  return null;
}
